import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Clock } from "lucide-react";

function format(sec) {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m}:${String(s).padStart(2, "0")}`;
}

export default function InactivityWarning({ open, remainingSec, onStay }) {
    return (
        <Dialog open={open} onOpenChange={() => { /* modal — only Stay closes it */ }}>
            <DialogContent data-testid="inactivity-warning" className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 asl-navy-text">
                        <Clock className="h-5 w-5 asl-crimson-text" />
                        Session expiring soon
                    </DialogTitle>
                </DialogHeader>
                <div className="space-y-3 text-sm">
                    <p>
                        You haven&apos;t interacted with the platform for a while. For security,
                        we&apos;ll sign you out automatically when the timer below reaches zero.
                    </p>
                    <div className="flex items-center justify-center py-2">
                        <span
                            className="text-4xl font-bold asl-navy-text mono"
                            data-testid="inactivity-countdown"
                        >
                            {format(remainingSec)}
                        </span>
                    </div>
                </div>
                <DialogFooter>
                    <Button
                        className="asl-navy-bg text-white w-full"
                        onClick={onStay}
                        data-testid="inactivity-stay"
                    >
                        Stay logged in
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
